import React from 'react'
import PropTypes from 'prop-types'

import { isEmpty } from 'lodash'
import { utils, cx } from 'passiv-libs'
import { AppWrapper } from 'passiv-components'
import Away from './away'
import Tile from './tile'

import renderPortal from './portal'

import { getTileWidth } from './utils'

const Dashboard = ({
  loading,
  portal,
  hotwater,
  links,
  allHeatingOccupancies,
  inOut,
  away,
  hotwaterModal,
  onClickTile
}) => {
  return (
    <AppWrapper
      dataContainer="dashboard"
      container={false}
      titleHeader="My home"
      renderPortal={renderPortal({ ...portal, inOut, away, hotwaterModal })}
      occupancyColour={utils.heating.getOccupancyColour(allHeatingOccupancies)}
      ariaHideHeader={away.show}
    >
      {away.show && <Away {...away} />}
      <div
        data-container="dashboard-main"
        className={cx(
          'max-w-80 md:max-h-80 m-auto',
          'overflow-auto',
          'grid grid-cols-2 gap-1 md:grid-cols-3'
        )}
        aria-hidden={away.show}
      >
        {links.map(
          (
            {
              dataContainer,
              id,
              name,
              ariaLabel,
              colour,
              icon,
              link,
              badge,
              awayTile,
              occupancy = [{}, {}],
              airTemperature,
              airTemperatureAriaLabel,
              disabled
            },
            i
          ) => {
            const size = getTileWidth({
              quantity: links.length,
              isLast: i + 1 === links.length,
              isLarge: window.matchMedia('(min-width: 769px)').matches
            })
            const width =
              size === 'triple'
                ? 'calc(300% + 16px)'
                : size === 'double'
                  ? 'calc(200% + 8px)'
                  : '100%'
            return (
              <div
                key={`${name}-${i}`}
                className={cx('relative pt-full h-0', `tile-${size}`, { ['disabled']: disabled })}
                style={{ width }}
              >
                <div className="absolute inset-0">
                  <Tile
                    loading={loading}
                    hotwater={hotwater}
                    awayTile={awayTile}
                    dataContainer={dataContainer}
                    id={id}
                    disabled={disabled}
                    colour={colour}
                    icon={icon}
                    name={name}
                    ariaLabel={ariaLabel}
                    link={link}
                    occupancy={isEmpty(occupancy) ? allHeatingOccupancies : occupancy}
                    untilTimeText={inOut.untilTimeText}
                    onClick={onClickTile}
                    airTemperature={airTemperature}
                    airTemperatureAriaLabel={airTemperatureAriaLabel}
                    badge={badge}
                  />
                </div>
              </div>
            )
          }
        )}
      </div>
    </AppWrapper>
  )
}

const shapes = {
  tipModal: PropTypes.shape({
    id: PropTypes.string,
    ref: PropTypes.object,
    open: PropTypes.bool,
    tip: PropTypes.bool,
    text: PropTypes.string,
    onClick: PropTypes.func,
    onClickTip: PropTypes.func
  })
}

Dashboard.propTypes = {
  loading: PropTypes.bool,
  portal: PropTypes.object,
  hotwater: PropTypes.object,
  inOut: PropTypes.shape({
    tipModalIn: shapes.tipModal,
    tipModalOut: shapes.tipModal,
    timeModal: PropTypes.shape({
      open: PropTypes.bool,
      mobiscroll: PropTypes.shape({
        name: PropTypes.string,
        disabled: PropTypes.bool,
        value: PropTypes.string,
        onChange: PropTypes.func
      }),
      buttons: PropTypes.array
    }),
    untilTimeText: PropTypes.string
  }),
  links: PropTypes.array,
  occupancy: PropTypes.array,
  away: PropTypes.shape({
    start: PropTypes.shape({
      open: PropTypes.bool
    })
  }),
  onClickTile: PropTypes.func
}

export default Dashboard
